import Vue from 'vue'
import ElementUI from 'element-ui'
import Vuesax from 'vuesax'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'

// import 'element-ui/lib/theme-chalk/index.css'
import './assets/element-io/index.css'
import 'vuesax/dist/vuesax.css'

Vue.config.productionTip = false
Vue.use(Vuesax)
Vue.use(ElementUI)

new Vue({
  router,
  render: h => h(App)
}).$mount('#app')
